export class VistaRegistroDiarioSipagoFilter {
  id_area_minera?: number;
  id_subcuenta?: number;
  numero_formulario?: string;
  fecha_pago?: Date;
  solicitante?: string;
  debe?: number;
}
